var check = 0;
var CartVar = setInterval(Carttimer, 500);

function Carttimer() {
  if (window.$) {
    $(document).on("swell:setup", function () {
      if (check != 1) {
        $(".swell-referral-loader-tiers").hide();
        $(".swell-cart-page").show();
        swellAPI.populateSelectWithRedemptionOptions("select#redemptionoptions");
        $(".swell-redeem-btn").click(function () {
          $(".swell-redeem-btn-title").hide();
          $(".swell-referral-loader-redeem").show();
          var redemptionOptionSelect = $("#redemptionoptions");
          var value = redemptionOptionSelect.val();
          var selection = swellAPI.findActiveRedemptionOptionById(value);
          $("#swell-reward-heading").html("<h4>" + selection.name + "</h4>");
          $("#swell-coupon-intro").html("<p>" + selection.description + "</p>");

          var onSuccess = function (redemption) {
            $("#swell-reward-intro").html("<p>" + redemption.redemptionOption.reward_intro + "</p>");
            $("#swell-coupon-code").html("<p>" + redemption.couponCode + "</p>");
            $(".swell-modal").css("display", "block");
            $(".swell-redeem-btn-title").show();
            $(".swell-referral-loader-redeem").hide();
          };

          var onError = function (err) {
            $("#swell-reward-intro").hide();
            $("#swell-coupon-code").hide();
            $("#swell-redemption-error").html("Sorry, you don't have enough points for this reward.");
            $(".swell-modal").css("display", "block");
            $(".swell-redeem-btn-title").show();
            $(".swell-referral-loader-redeem").hide();
          };

          swellAPI.makeRedemption({
              redemptionOptionId: redemptionOptionSelect.val()
            },
            onSuccess,
            onError
          );
        });

        $(".swell-closepop-btn").click(function () {
          $(".swell-modal").css("display", "none");
        });
        stopCart();
        check = 1;
      }
    });
  }
}

function stopCart() {
  clearInterval(CartVar);
}
